// Частые вопросы (FAQ).
export const faq = [
  {
    q: "Нужен ли проект перед монтажом?",
    a: "Для квартиры с типовой сплит-системой проект не обязателен. Но для вентиляции дома, коттеджа или коммерческого объекта проект необходим: он фиксирует расчёт воздухообмена, схему трасс и спецификацию оборудования — это исключает переделки и даёт предсказуемый бюджет.",
  },
  {
    q: "Сколько стоит вентиляция или кондиционирование?",
    a: "Стоимость зависит от площади, типа объекта, выбранного оборудования и сложности монтажа. После выезда инженера и замера мы готовим точную смету. Предварительный расчёт можно получить бесплатно — оставьте заявку, и мы перезвоним в течение 15 минут.",
  },
  {
    q: "Делаете ли монтаж в готовом ремонте?",
    a: "Да. Подбираем решения, которые можно смонтировать без капитальной переделки: настенные и напольные блоки, наружную прокладку трасс в коробах, компактные приточные установки. На замере инженер предложит оптимальный вариант под ваш интерьер.",
  },
  {
    q: "Какие сроки выполнения работ?",
    a: "Монтаж сплит-системы — обычно 1 день. Вентиляция квартиры — 2–5 дней, дома или коттеджа — от 2–3 недель. Крупные коммерческие объекты — от месяца. Точные сроки фиксируются в договоре после проекта.",
  },
  {
    q: "Работаете ли с юридическими лицами?",
    a: "Да, работаем как с частными, так и с юридическими лицами. Заключаем договор, предоставляем полный пакет документов, работаем с НДС. Для коммерческих объектов выполняем проектирование по разделам ОВ, ВК и ЭОМ.",
  },
  {
    q: "Какая гарантия на работы и оборудование?",
    a: "На монтажные работы предоставляем гарантию 1 год. Гарантия на оборудование — от производителя (как правило 1–3 года). Также предлагаем сервисное обслуживание, которое продлевает срок службы систем.",
  },
  {
    q: "Нужно ли обслуживать климатические системы?",
    a: "Да. Кондиционеры и вентиляция требуют регулярного обслуживания: чистка фильтров, проверка хладагента, ревизия автоматики. Это сохраняет производительность, снижает счета за электричество и предотвращает поломки. Заключаем договоры на сервисное ТО.",
  },
];
